import React, {FC} from "react";
import {Company as ICompany} from "../../../../types/types";

export const CompanyInfo:FC<{company?: ICompany}> = ({company}) => {
    return <div style={{margin: 12}}>
        {company?.name}
    </div>
}
    